import auth from '../modules/auth/store'

export default {
    auth
}
